import { getSlides, getCaseBySlug, getPageBySlug, getFooter, getCaseById, getPosts, getPostBySlug, getRelatedPosts, getCategoryBySlug, getPostsByCategory, getAuthorBySlug, getPostsByAuthor, getComments, postComment, getThreadComments } from '../utils/axios';

export default {
    fetchSlides({ commit, state }) {
        getSlides().then(({data}) => {
          const slidesResponse = data.acf.page_slides;
          const slides = slidesResponse.map((slide, index) => ({
                  ...slide,
                  video: slide.acf.video,
                  img: slide.featured_image_url,
                  url: slide.type === 'link_slide' ? slide.acf.outgoing_url.url : slide.link,
                  title: slide.title.rendered,
                  excerpt: slide.excerpt.rendered,
                  frontSlide: !data.acf.slide_title && index === 0,
                  color: slide.acf.color_theme || 'white',
                  themeColor: slide.acf.theme_color || 'white',
                  buttonClass: slide.acf.button_style,
          }));
          let frontSlide = [];
          if (data.acf.slide_title) {
            frontSlide = [{
              title: data.acf.slide_title,
              excerpt: data.acf.slide_description,
              url: null,
              video: data.acf.video,
              img: data.acf.slide_image,
              id: 'firstSlide',
              frontSlide: true,
              color: data.acf.primary_color || 'white',
              themeColor: data.acf.theme_color || 'white',
            }];
          }
          const slidesWithFront = [...frontSlide, ...slides];
          slidesWithFront.forEach(slide => {
            if (slide.img) {
              var img = new Image();
              img.src = slide.img;
            }
          });
          commit('setHero', {originalSlides: [...slidesWithFront]});
          if (!state.hero.slides.length && state.hero.showSlideShow) {
            commit('setHero', {slides: slidesWithFront, frontSlide});
          }
        });
      },
      async getCase({ commit, state }, slug) {
        const fetchedCase = await getCaseBySlug(slug);
        return fetchedCase.data[0];
      },
      async getPosts(ctx, params) {
        const fetchedPosts = await getPosts(params);
        return fetchedPosts;
      },
      async getComments(ctx, params) {
        const fetchedComments = await getComments(params);
        return fetchedComments;
      },
      async getThreadComments(ctx, params) {
        const fetchedComments = await getThreadComments(params);
        return fetchedComments;
      },
      async postComment(ctx, params) {
        try {
          const postedComment = await postComment(params);
          return postedComment;
        } catch(err) {
          console.error(err);
        }
      },
      async getRelatedPosts(ctx, params) {
        const fetchedRelatedPosts = await getRelatedPosts(params);
        return fetchedRelatedPosts;
      },
      async getPost({ commit, state }, slug) {
        const fetchedPost = await getPostBySlug(slug);
        return fetchedPost.data[0];
      },
      async getCategory(ctx, slug) {
        const fetchedCategory = await getCategoryBySlug(slug);
        return fetchedCategory.data[0];
      },
      async getAuthor(ctx, slug) {
        const fetchedAuthor = await getAuthorBySlug(slug);
        return fetchedAuthor.data[0];
      },
      async getPostsByCategory(ctx, id) {
        const fetchedPosts = await getPostsByCategory(id);
        return fetchedPosts;
      },
      async getPostsByAuthor(ctx, name) {
        const fetchedPosts = await getPostsByAuthor(name);
        return fetchedPosts.data;
      },
      async getCaseById({ commit, state }, id) {
        const fetchedCase = await getCaseById(id);
        return fetchedCase.data;
      },
      getPage({ commit }, slug) {
        return getPageBySlug(slug).then(({data: [page]}) => {
          return page;
        });
      },
      async getFooter({ commit, state: { footer } }) {
        if (footer) {
          return footer;
        }
        const { data: { acf } } = await getFooter();
        commit('setFooter', acf)
        return acf;
      }
      
}